import React from 'react'

import {
  FormulaStyled,
  FormulaHeadingStyled,
  FormulaTitleStyled,
  FormulaBadgeStyled,
  FormulaListStyled,
  FormulaListItemStyled,
  FormulaListItemContentStyled,
  FormulaListItemContentTitleStyled,
  FormulaListItemContentDescStyled,
  FormulaNoteStyled
} from './styles'
import { FormulaProps } from './types'
import TextBadge from './../../atoms/TextBadge'

const Formula: React.FC<FormulaProps> = ({ data: { heading, list, note } }) => {
  return (
    <FormulaStyled>
      <FormulaHeadingStyled>{heading}</FormulaHeadingStyled>
      {list?.title && <FormulaTitleStyled as="p">{list.title}</FormulaTitleStyled>}
      {list?.badge && (
        <FormulaBadgeStyled>
          <TextBadge text={list.badge} />
        </FormulaBadgeStyled>
      )}
      {list?.items && (
        <FormulaListStyled>
          {list.items.map(({ key, title, content }) => (
            <FormulaListItemStyled {...{ key }}>
              <FormulaListItemContentStyled>
                <FormulaListItemContentTitleStyled>{title}</FormulaListItemContentTitleStyled>
                <FormulaListItemContentDescStyled>{content}</FormulaListItemContentDescStyled>
              </FormulaListItemContentStyled>
            </FormulaListItemStyled>
          ))}
        </FormulaListStyled>
      )}
      {note && <FormulaNoteStyled dangerouslySetInnerHTML={{ __html: note }} />}
    </FormulaStyled>
  )
}

export default Formula
